import React, { useState, useEffect } from "react";
import Voitures from "../assets/data/voitures.json";
import Button from "../components/Bouton"
import LeftArrow from "../assets/arrow-circle-left-svgrepo-com.png";
import RightArrow from "../assets/arrow-circle-right-svgrepo-com.png";

export default function Carrousel(props) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const [direction, setDirection] = useState('next');
    const selectedCar = Voitures[currentIndex];
    
    const prevHandler = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setDirection('prev');
        currentIndex === 0 ? setCurrentIndex(Voitures.length - 1) : setCurrentIndex(currentIndex - 1);
    };
    
    const nextHandler = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setDirection('next');
        currentIndex === Voitures.length - 1 ? setCurrentIndex(0) : setCurrentIndex(currentIndex + 1);
    };

    useEffect(() => {
        if (isAnimating) {
            const timer = setTimeout(() => {
                setIsAnimating(false);
            }, 600);
            return () => clearTimeout(timer);
        }
    }, [isAnimating]);
    return (
        <section className="carrousel">
            <div className="carrousel__container">
                <div className="car__image__container">
                    <div className="car__image__wrapper">
                        <img 
                            className={`car__image ${isAnimating ? `car__image--${direction}` : ''}`} 
                            src={selectedCar.image} 
                            alt={selectedCar.titre}
                        />
                        <div className="car__image__overlay"></div>
                    </div>
                    <h2 className={`car__title ${isAnimating ? `car__title--${direction}` : ''}`}>
                        {selectedCar.titre}
                    </h2>
                    <div className="car__indicators">
                        {Voitures.map((_, index) => (
                            <button
                                key={index}
                                className={`car__indicator ${index === currentIndex ? 'active' : ''}`}
                                onClick={() => {
                                    if (isAnimating) return;
                                    setIsAnimating(true);
                                    setDirection(index > currentIndex ? 'next' : 'prev');
                                    setCurrentIndex(index);
                                }}
                            />
                        ))}
                    </div>
                </div>
                
                <div className="car__description">
                    <div className="car__description__content">
                        <div className="car__description__text">
                            <p className={`car__description__paragraph ${isAnimating ? `car__description__paragraph--${direction}` : ''}`}>
                                {selectedCar.description}
                            </p>
                        </div>
                        
                        <div className="car__description__buttons">
                            <Button 
                                Text="Découvrir"
                                Link={selectedCar.essai}
                                className="car__button car__button--primary"
                            />
                            <Button 
                                Text="Configurer mon Alpine"
                                Link={selectedCar.configurez}
                                className="car__button car__button--secondary"
                            />
                        </div>
                    </div>
                    
                    <div className="carrousel__controls">
                        <button 
                            className={`carrousel__arrow carrousel__arrow--left ${isAnimating ? 'disabled' : ''}`}
                            onClick={prevHandler}
                            disabled={isAnimating}
                        >
                            <img src={LeftArrow} alt="Précédent" />
                        </button>
                        
                        <div className="carrousel__info">
                            <span className="carrousel__counter">
                                {currentIndex + 1} / {Voitures.length}
                            </span>
                            <span className="carrousel__model">{selectedCar.titre}</span>
                        </div>
                        
                        <button 
                            className={`carrousel__arrow carrousel__arrow--right ${isAnimating ? 'disabled' : ''}`}
                            onClick={nextHandler}
                            disabled={isAnimating}
                        >
                            <img src={RightArrow} alt="Suivant" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}